import {GrammarlyEditorPlugin} from '@grammarly/editor-sdk-react';
import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../libs/shared/core/src/services/tracking/tracking';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {getIsGrammarlyAllEnabled} from './grammarlySelectors';

/*
 * Props.
 */

interface GrammarlyEditorPluginWrapperProps {
  children: ReactNode;
  hasGrammarlySupport?: boolean;
  isComment: boolean;
  isReply: boolean;
}

/*
 * Style.
 */

const StyledGrammarlyEditorPlugin = styled(GrammarlyEditorPlugin)`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

/*
 * Components.
 */

// Wrapper for GrammarlyEditorPlugin, used for adding the plugin to contentEditables, text fields, etc
export const GrammarlyEditorPluginWrapper: FC<PropsWithChildren<GrammarlyEditorPluginWrapperProps>> = ({
  children,
  hasGrammarlySupport,
  ...props
}) => {
  const isGrammarlyAllEnabled = useAppSelector(getIsGrammarlyAllEnabled);

  if (!hasGrammarlySupport || !isGrammarlyAllEnabled) {
    return <>{children}</>;
  }
  return (
    <StyledGrammarlyEditorPlugin
      onSuggestionCardOpen={() =>
        trackInterfaceEvent(InterfaceEventsEnum.GRAMMARLY_COMPOSER_SUGGESTION_VIEW, {
          source: 'grammarly',
          is_reply: Boolean(props.isReply),
          is_comment: Boolean(props.isComment),
        })
      }
    >
      {children}
    </StyledGrammarlyEditorPlugin>
  );
};
